<template>
  <div id="app">
    <router-view/>
    <paper-download-list
      :visible="downloadListVisible"
      :collapsed="downloadListCollapsed"
      :tasks="downloadTasks"
      :summary="downloadTaskSummary"
      :language="language"
      :can-open-task="canOpenDownloadTask"
      @toggle-collapse="downloadListCollapsed = !downloadListCollapsed"
      @close="closeDownloadList"
      @open-task="openDownloadTask"
      @retry-task="retryDownloadTask"
      @remove-task="removeDownloadTask"
    ></paper-download-list>
  </div>
</template>

<script>
import PaperDownloadList from '@/components/PaperDownloadList.vue'
import downloadCenter from '@/utils/downloadCenter'
import { getLanguage } from '@/api/auth'

export default {
  components: {
    PaperDownloadList
  },
  data () {
    return {
      language: getLanguage()
    }
  },
  computed: {
    downloadTasks() {
      return downloadCenter.state.tasks
    },
    downloadListVisible() {
      return downloadCenter.state.visible
    },
    downloadListCollapsed: {
      get() {
        return downloadCenter.state.collapsed
      },
      set(value) {
        downloadCenter.state.collapsed = !!value
      }
    },
    downloadTaskSummary() {
      return downloadCenter.getSummary(this.language)
    }
  },
  mounted() {
    if (typeof window !== 'undefined') {
      window.addEventListener('viwoods-language-change', this.handleLanguageChange)
    }
  },
  beforeDestroy() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('viwoods-language-change', this.handleLanguageChange)
    }
  },
  methods: {
    handleLanguageChange(event) {
      this.language = event && event.detail && event.detail.language ? event.detail.language : getLanguage()
    },
    canOpenDownloadTask(task) {
      return downloadCenter.canOpenTask(task)
    },
    openDownloadTask(task) {
      downloadCenter.openTask(task)
    },
    retryDownloadTask(task) {
      downloadCenter.retryTask(task)
    },
    removeDownloadTask(task) {
      downloadCenter.removeTask(task)
    },
    closeDownloadList() {
      downloadCenter.closeList()
    }
  }
}
</script>

<style>
:root {
  --viwoods-loading-color: #1F3A2D;
}

button,
input[type="button"],
input[type="submit"],
input[type="reset"],
.ant-btn,
.button,
[class*="-button"],
[class*="_button"],
.switch-login,
.send-code,
.open-setting,
.right_block {
  border-radius: 0 !important;
}

.ant-input:hover:not(:focus):not(.ant-input-focused),
.ant-input-affix-wrapper:hover:not(.ant-input-affix-wrapper-focused),
input:hover:not(:focus),
textarea:hover:not(:focus) {
  border-color: #d9d9d9 !important;
}

#app .ant-spin-nested-loading .ant-spin .ant-spin-dot,
#app .ant-spin-spinning .ant-spin-dot {
  color: var(--viwoods-loading-color) !important;
}

#app .ant-spin-nested-loading .ant-spin .ant-spin-dot .ant-spin-dot-item,
#app .ant-spin-spinning .ant-spin-dot .ant-spin-dot-item {
  background-color: var(--viwoods-loading-color) !important;
}

#app .ant-spin-text {
  color: var(--viwoods-loading-color) !important;
}

body .cloud-setting-modal .ant-spin-spinning .ant-spin-dot,
body .cloud-setting-modal .ant-spin-nested-loading .ant-spin .ant-spin-dot {
  color: var(--viwoods-loading-color) !important;
}

body .cloud-setting-modal .ant-spin-spinning .ant-spin-dot .ant-spin-dot-item,
body .cloud-setting-modal .ant-spin-nested-loading .ant-spin .ant-spin-dot .ant-spin-dot-item {
  background-color: var(--viwoods-loading-color) !important;
}

html body .custom-loading .el-loading-spinner .path,
html body .el-loading-spinner .path {
  stroke: var(--viwoods-loading-color) !important;
}

html body .custom-loading .el-loading-spinner .circular,
html body .el-loading-spinner .circular {
  color: var(--viwoods-loading-color) !important;
}

html body .custom-loading .el-loading-spinner > div,
html body .el-loading-spinner > div {
  border-color: var(--viwoods-loading-color) transparent transparent transparent !important;
}

html body .custom-loading .el-loading-text,
html body .el-loading-text,
html body .el-icon-loading {
  color: var(--viwoods-loading-color) !important;
}

.is-interaction-locked {
  position: relative;
}

.is-interaction-locked::after {
  content: '';
  position: fixed;
  inset: 0;
  z-index: 4000;
  background: transparent;
  cursor: wait;
  pointer-events: auto;
  touch-action: none;
}
</style>
